import * as React from 'react';
import styles from './index.module.sass'
import Slider from '../Slider';
import { animate } from '../../lib/animation';
import Viewer from '../Scene/viewer';
import { CLOSE_WITH_LOADER, CLOSE_LOADED } from '../../constants/animationConstants';
import { TRUCK_SELECT } from '../../constants/commonContsnts';
import { Truck } from 'types/data';

interface ITruckSelectProps {
  trucks: Truck[],
  setTruck: Function,
  selectedTruck: Truck | null,
  viewerApi?: Viewer
}

interface OnSelect {
  content: Truck,
  animationItems: any,
}

const loadingInitState = {
  progress: 0,
  max: 100
}

const loadingReducer = (state: any, action: {type: string, payload?: any}) => {
  switch(action.type) {
    case 'ADD1': {
      const progressAdding = state.progress > 80 ? 0.25 : .5
        return {
          ...state,
          progress: state.progress === 100 ? state.progress : state.progress + progressAdding
        }
    }
    case 'SET100': {
      return {
        ...state,
        progress: 100
      }
    }
  } 
}

const TruckSelect: React.FunctionComponent<ITruckSelectProps> = ({trucks, setTruck, selectedTruck, viewerApi}) => {
  const root = React.useRef<HTMLDivElement>(null)
  const [isSelected, setSelected] = React.useState(false)
  const [loading, setLoading] = React.useReducer(loadingReducer, loadingInitState)
  
  const items = trucks.map((item => ({
    image: item.image,
    title: item.name,
    subTitle: 'ECO-LITE',
    item
  })))

  const addLoadingProgress = () => {
    setLoading({
      type: 'ADD1'
    })
  }

  const endLoading = () => {
    setLoading({
      type: 'SET100'
    })
  }

  
  const onSelect = async (props: OnSelect) => {
    if(!isSelected) {
      setSelected(true)
      const { content, animationItems } = props
      
      await animate(animationItems, CLOSE_WITH_LOADER)
      
      await viewerApi!.initLoading(content, endLoading, addLoadingProgress)
      
      await animate(animationItems, CLOSE_LOADED)

      root.current!.style.pointerEvents = 'none'

      viewerApi!.blurNode()

      setTruck(content)
    }
  }
  
  return (
    <div className={styles.root} ref={root}>
      <div className={styles.wrapper}>
        <Slider items={items} loading={loading} onSelect={loading.progress < 1 ? onSelect : () => {}} type={TRUCK_SELECT}/>
      </div>
    </div>
  );
};

export default TruckSelect;
